import React from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';

// components
import SettlementHeaderComponent from '../../../components/Settlements/SettlementtHeader/SettlementHeader.Component';
import SettlementResumeListComponent from '../../../components/Settlements/SettlementResumeList/SettlementResumeList.Component';
import SettlementTotalComponent from '../../../components/Settlements/SettlementTotal/SettlementTotal.Component';
import SettlementProtocolBreakdownComponent from '../../../components/Settlements/SettlementProtocolBreakdown/SettlementProtocolBreakdown.Component';
import SettlementConceptsBreakdownComponent from '../../../components/Settlements/SettlementConceptsBreakdown/SettlementConceptsBreakdown.Component';

////i18Next
import { useTranslation } from 'react-i18next';

//styles
import './SettlementDetails.Styles.css';

export const SettlementDetailsPage = () => {

  const { SettlementId } = useParams();
  const [t] = useTranslation();

  return (
    <>
        <PageHeader title={t('settlementDetailsPage.settlementDetailsTitle')}/>
        <div className="sd-page">
            <SettlementHeaderComponent SettlementId={Number(SettlementId)} />
            <div className="sd-content">
                <div className="sd-main">
                    <SettlementResumeListComponent SettlementId={Number(SettlementId)} />
                    {/* Al pie del detalle: cuánto se cobró por cada concepto */}
                    <SettlementConceptsBreakdownComponent SettlementId={Number(SettlementId)} />
                </div>
                <aside className="sd-sidebar">
                    <SettlementTotalComponent SettlementId={Number(SettlementId)} />
                    {/* Sólo aparece en liquidaciones a médico o con varios protocolos */}
                    <SettlementProtocolBreakdownComponent SettlementId={Number(SettlementId)} />
                </aside>
            </div>
        </div>
    </>
  );
};
